export enum PersonnelVersion {
  Basic = 0,
  Stock = 5,
  Classic = 10,
}
